import { isBrowser } from '@webapp/common/lib/const';

export const isOfflineMode = (): boolean => {
    if (!isBrowser) return false;
    const { pathname } = new URL(document.location.href);
    return pathname === '/offline';
};
